<template>
  <div ref="element" />
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import type { AnimationItem } from 'lottie-web'

type AnimationName =
  | 'New-File'
  | 'Empty-Folder'
  | 'Archived-Files'
  | 'Search-Results'
  | 'Infinite-Files'
  | 'Infringement-Notice'

const props = defineProps<{
  name: AnimationName
  loop?: boolean
}>()

const element = ref<HTMLElement>()
const animation = ref<AnimationItem>()

onMounted(async () => {
  if (!element.value) return

  const lottie = await import('lottie-web')

  animation.value = lottie.default.loadAnimation({
    container: element.value,
    path: new URL(`../../assets/animations/${props.name}.json`, import.meta.url)
      .href,
    loop: props.loop || false,
    rendererSettings: {
      filterSize: {
        width: '200%',
        height: '200%',
        x: '-50%',
        y: '-50%',
      },
    },
  })
})
</script>
